import { render, staticRenderFns } from "./CommentsIcon.vue?vue&type=template&id=5b2bfc95"
import script from "./CommentsIcon.vue?vue&type=script&lang=js"
export * from "./CommentsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports